/**
 * Paddle configuration
 *
 * The environment is never defaulted — an unset/invalid VITE_PADDLE_ENV throws
 * immediately so the app can't accidentally talk to the wrong Paddle account.
 */
import type { Environments } from '@paddle/paddle-js'

const rawEnv = import.meta.env.VITE_PADDLE_ENV

if (rawEnv !== 'sandbox' && rawEnv !== 'production') {
    throw new Error(
        `VITE_PADDLE_ENV must be set to "sandbox" or "production" (got: ${JSON.stringify(rawEnv)}). Refusing to guess which Paddle account to use.`,
    )
}

if (!import.meta.env.VITE_PADDLE_CLIENT_TOKEN) {
    throw new Error('VITE_PADDLE_CLIENT_TOKEN is not set.')
}

// Live is Paddle.js's default, so `environment` is only set for sandbox.
export const paddleConfig = {
    token: import.meta.env.VITE_PADDLE_CLIENT_TOKEN,
    ...(rawEnv === 'sandbox' && { environment: 'sandbox' as Environments }),
} as const
